import { useState, MouseEvent } from "react";
import { Box, Button, Menu, MenuItem } from "@mui/material";
import { Typography } from "@platform/design-system";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { StatusType } from "../types";

type Props = {
  id: number;
  onChange: (status: StatusType) => void;
  current: StatusType | null;
  next: StatusType[];
  isPending: boolean;
};

function Status({
  onChange,
  current,
  next,
  isPending,
}: Props): React.JSX.Element | null {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const open = Boolean(anchorEl);
  function handleMenuClose(e: MouseEvent) {
    e.stopPropagation();
    setAnchorEl(null);
  }

  // This should never happen, but just in case
  if (current === null) {
    return null;
  }

  const hasNext = next.length > 0;
  return (
    <>
      <Box
        component="span"
        display="flex"
        alignItems="center"
        sx={{ color: "neutrals.neutral_700" }}
      >
        <Typography component="span" color="inherit">
          Status:{" "}
        </Typography>
        {hasNext ? (
          <Button
            onClick={(e) => {
              e.stopPropagation();
              setAnchorEl(e.currentTarget);
            }}
            loading={isPending}
            endIcon={<ExpandMoreIcon fontSize="small" />}
            variant="text"
            sx={{ fontSize: 16, textTransform: "none" }}
          >
            {current.text}
          </Button>
        ) : (
          <Typography component="span" color="inherit" px={1}>
            {current.text}
          </Typography>
        )}
      </Box>

      {hasNext ? (
        <Menu open={open} anchorEl={anchorEl} onClose={handleMenuClose}>
          {next.map((status) => (
            <MenuItem
              key={status.value}
              onClick={(e) => {
                onChange(status);
                handleMenuClose(e);
              }}
            >
              {status.text}
            </MenuItem>
          ))}
        </Menu>
      ) : null}
    </>
  );
}

export default Status;
